import React from "react";

const VARIANTS = {
    primary: "bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 disabled:bg-brand-300",
    secondary: "bg-white text-ink-800 border border-ink-200 disabled:text-ink-400",
    ghost: "bg-transparent text-ink-700 hover:bg-ink-100 active:bg-ink-200 disabled:text-ink-400",
    danger: "bg-danger-600 text-white hover:bg-danger-700 active:bg-danger-800 disabled:bg-danger-300",
    success:
        "bg-success-600 text-white hover:bg-success-700 active:bg-success-800 disabled:bg-success-300 shadow-sm ring-1 ring-success-700/20",
    successOutline:
        "border border-success-600 bg-white text-success-700 hover:bg-success-50 hover:border-success-700 active:bg-success-100 disabled:border-success-200 disabled:bg-white disabled:text-success-300",
};

const SIZES = {
    sm: "h-8 px-3 text-sm",
    md: "h-10 px-4 text-sm",
    lg: "h-11 px-5 text-base",
};

const Button = React.forwardRef(function Button(
    {
        as: As = "button",
        variant = "primary",
        size = "md",
        className = "",
        leadingIcon = null,
        trailingIcon = null,
        children,
        type,
        ...rest
    },
    ref,
) {
    const base =
        "inline-flex items-center justify-center gap-2 rounded-lg font-medium transition duration-150 ease-out focus:outline-none disabled:cursor-not-allowed";
    const cls = `${base} ${SIZES[size] || SIZES.md} ${
        VARIANTS[variant] || VARIANTS.primary
    } ${className}`;

    return (
        <As
            ref={ref}
            className={cls}
            type={As === "button" ? type || "button" : type}
            {...rest}
            data-ui-button=""
            data-variant={variant}
        >
            {leadingIcon && <span aria-hidden="true">{leadingIcon}</span>}
            {children}
            {trailingIcon && <span aria-hidden="true">{trailingIcon}</span>}
        </As>
    );
});

export default Button;
